import React from 'react';
import { Grid, Button, Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import LockIcon from '@material-ui/icons/Lock';
import { trackActivity } from '../../../utils/mixpanel';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
const AppsCard = ({item, opticFlag= false}) => {
    const opticInfoText = "OPTIC is a teardown, consignment management and reporting application intended to significantly de-risk the entire teardown and consignment process. OPTIC is a wholly developed and owned digital platform belonging to SellUe. OPTIC adds value to SPARTA customers by providing a solution for Asset Teardown and Consignment management which is the final frontier in the asset lifecycle. To explore, click on the widget or reach out to SPARTA Team at support@sparta.aero to arrange a demo in collaboration with SellUE Product Support team. "
    return(
        <Grid item lg={4} md={6}>
            <div className={`application-card ${!item.access ? 'no-access-app':''}`} onClick={(e) => {item.access ? window.open(item.url, '_blank').focus():e.preventDefault(); trackActivity('Console Management', { page_title: 'App Card',  event_type: 'Item Clicked ', event_desc: `Clicked on ${item.label} card` })}}>
                {!item.access ? <Tooltip title='' arrow><LockIcon className='lock-icon' fontSize='small' color='primary' /></Tooltip>:null}
                <div className='app-title ' style={{display:'-webkit-flex',alignItems:'center'}}>
                {item?.logo?.includes('optic_logo') ? <img src={item.logo} alt={item.label} style={{width:"100px"}}/> : <img src={item.logo} alt={item.label} style={{objectFit:"scale-down"}}/>}
                    <h4>
                        {item.label}
                        {opticFlag ?
                        <Tooltip arrow title={<p style={{fontSize: "12px" }}>{opticInfoText}</p>}>
                            <InfoIcon fontSize='small' style={{verticalAlign:'bottom', marginLeft:'3px'}} />
                        </Tooltip> : null }
                        {item.isBeta ? <sup> Beta</sup>:null}
                    </h4>
                </div>

                <div className='app-desc'>
                    <p>{item.description}</p>
                </div>
                {item.access ? <Button size='small' endIcon={<ChevronRightIcon fontSize='small'/>}>Access</Button>:<span className='no-access-content'>Please contact support@sparta.aero to access this application</span>}
            </div>
        </Grid>
    )
}
export default AppsCard;